/* Face-local artwork alignment. Distances are evaluated in screen pixels. */
(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.MyersCADEmbossSnap=api;})(typeof globalThis!=='undefined'?globalThis:this,()=>{
  const add=(a,b)=>a.map((v,i)=>v+b[i]),sub=(a,b)=>a.map((v,i)=>v-b[i]),mul=(a,s)=>a.map(v=>v*s),dot=(a,b)=>a.reduce((s,v,i)=>s+v*b[i],0),length=a=>Math.hypot(...a),cross=(a,b)=>[a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]];
  function face(triangles,edges){
    let center=[0,0,0],area=0;
    for(const [a,b,c]of triangles){const weight=length(cross(sub(b,a),sub(c,a)));area+=weight;center=add(center,mul(add(add(a,b),c),weight/3));}
    if(!area)return null;center=mul(center,1/area);
    edges=edges.filter(([a,b])=>length(sub(b,a))>1e-7).map(e=>e.map(p=>p.slice()));
    // Triangulation may split an otherwise straight face boundary.
    let changed=true;
    while(changed&&edges.length<300){changed=false;outer:for(let i=0;i<edges.length;i++)for(let j=i+1;j<edges.length;j++){
      const a=edges[i],b=edges[j];for(let x=0;x<2;x++)for(let y=0;y<2;y++)if(length(sub(a[x],b[y]))<1e-6){const u=sub(a[1-x],a[x]),v=sub(b[1-y],b[y]);if(dot(u,v)/(length(u)*length(v))<-.99999){edges[i]=[a[1-x],b[1-y]];edges.splice(j,1);changed=true;break outer;}}
    }}
    return{center,edges};
  }
  function snap({face,point,normal,offsets,project,tolerance=14,bypass=false,valid=()=>true}){
    if(bypass||!face)return null;
    const cursor=project(point),distance=p=>{const q=project(p);return Math.hypot(q[0]-cursor[0],q[1]-cursor[1]);},candidates=[];
    const push=(kind,priority,anchor,position)=>{const d=distance(anchor);if(d<=tolerance)candidates.push({kind,priority,anchor,point:position,distance:d});};
    push('Face center',0,face.center,face.center);
    for(const [a,b]of face.edges){
      const edge=sub(b,a),len=length(edge);let inward=cross(normal,mul(edge,1/len));
      if(dot(inward,sub(face.center,a))<0)inward=mul(inward,-1);
      const align=(anchor,direction)=>add(anchor,mul(direction,.08-Math.min(...offsets.map(p=>dot(p,direction)))));
      const midpoint=mul(add(a,b),.5);push('Edge midpoint',1,midpoint,align(midpoint,inward));
      const t=Math.max(0,Math.min(1,dot(sub(point,a),edge)/(len*len))),nearest=add(a,mul(edge,t));
      push('Edge',2,nearest,align(nearest,inward));
      // A hole or concave boundary can have material on the opposite side.
      const opposite=mul(inward,-1);push('Edge midpoint',1,midpoint,align(midpoint,opposite));push('Edge',2,nearest,align(nearest,opposite));
    }
    return candidates.sort((a,b)=>a.priority-b.priority||a.distance-b.distance).find(candidate=>valid(candidate.point))||null;
  }
  return{face,snap};
});
